import { useEffect, useState } from 'react'
import { Icon } from '../../components/Icon'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { MOBILE_QUERY, TOUCH_SCREEN_QUERY } from '../../lib/platform'
import { useGestureTip } from '../../state/gestureTip'

/**
 * Once, on a phone: it counts as seen as soon as it appears, and stays in that conversation until dismissed, a
 * swipe or hold is used, or the conversation is left.
 */
export function GestureTip() {
  const phone = useMediaQuery(MOBILE_QUERY)
  const touch = useMediaQuery(TOUCH_SCREEN_QUERY)
  const seen = useGestureTip((s) => s.seen)
  const used = useGestureTip((s) => s.used)
  const [showing, setShowing] = useState(() => phone && touch && !seen)

  useEffect(() => {
    if (showing) useGestureTip.getState().markSeen()
  }, [showing])

  if (!showing || used) return null
  return (
    <div className="gesture-tip" role="note" aria-label="Tip">
      <Icon name="reply" />
      <p>Swipe a message right to reply, or hold it for more.</p>
      <button type="button" className="icon-button" aria-label="Dismiss tip" onClick={() => setShowing(false)}>
        <Icon name="x" />
      </button>
    </div>
  )
}
